<template>
    <div class="floor">
        <!-- 楼层标题 -->
        <div class="floor_title">
            <div class="floor_title_content" style="width: 100%;">
                <!-- <span class="floor_title_border"></span> -->
                <span class="floor_title_content_index" :style="{ color: floorConfig.curr.title.value.color }"
                    style="text-align: center;width: 100%;font-size: 25px;">{{ floorConfig.curr.title.value.text || "2F"
                    }}</span>
                <span class="floor_title_content_text" :style="{ color: floorConfig.curr.subTitle.value.color }"
                    style="text-align: center;width: 100%;font-size: 18px;">{{ floorConfig.curr.subTitle.value.text ||
                        "NiuShop" }}</span>
            </div>

            <!-- 右侧分类链接区 -->
            <div class="other-title" v-if="floorConfig.titleLink">
                <router-link :to="floorConfig.titleLink.url">{{ floorConfig.titleLink.content }} <i
                        class="iconfont iconarrow-right"></i></router-link>
            </div>
        </div>
        <!-- 楼层内容区 -->
        <div class="floor-content">
            <div class="floor-left">
                <cargo-item :cargo="item" v-for="(item, index) in skuList" :key="index" />
                <div style="width:17.3%;" v-for="item in 5 - skuList.length % 5"></div>
            </div>
        </div>
        <!-- <div class="floor-right">
            <div class="floor-right-top">
                <div class="top-first" @click="handleLinkClick(floorConfig.curr.bottomImg.value.link.url)">
                    <el-image v-if="floorConfig.curr.bottomImg.value.url" :src="$img(floorConfig.curr.bottomImg.value.url)" fit="cover" />
                </div>
                <div class="top-second" @click="handleLinkClick(floorConfig.curr.bottomImg.value.link.url)">
                    <el-image v-if="floorConfig.curr.bottomImg.value.url" :src="$img(floorConfig.curr.bottomImg.value.url)" fit="cover" />
                </div>
            </div>
            <div class="floor-right-bottom">
                <div class="bottom-first" @click="handleLinkClick(floorConfig.curr.bottomImg.value.link.url)">
                    <el-image v-if="floorConfig.curr.bottomImg.value.url" :src="$img(floorConfig.curr.bottomImg.value.url)" fit="cover" />
                </div>
                <div class="bottom-second" @click="handleLinkClick(floorConfig.curr.bottomImg.value.link.url)">
                    <el-image v-if="floorConfig.curr.bottomImg.value.url" :src="$img(floorConfig.curr.bottomImg.value.url)" fit="cover" />
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import CargoNormal from "@/components/cargo/CargoNormal"
import { floorGoods, goodsSkuList } from "@/api/goods/goods"
import CargoItem from "./cargo_item_1"

export default {
    name: "style2",
    components: {
        CargoNormal,
        CargoItem
    },
    props: {
        config: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            display: "",
            floorConfig: {
                validated: false,
                goodsList: {},
                subTitle: {},
                title: {},
                bottomImg: {}
            },
            skuList: []
        }
    },
    created() {
        this.$store.dispatch("site/defaultFiles")
        this.getSkuList()
    },
    computed: {
        ...mapGetters(["defaultGoodsImage"])
    },
    methods: {
        handleCargoClick(skuId) {
            if (skuId) {
                this.$router.pushToTab(`/sku-${skuId}`)
            }
        },
        handleLinkClick(url) {
            if (url) {
                this.$router.pushToTab(`${url}`)
            }
        },
        getSkuList() {
            const sku_ids = this.floorConfig.curr.goodsList.value.sku_ids  // null //
            // .map(item => {
            //     return item.sku_id
            // })
            // .toString()
            goodsSkuList({ sku_ids })
                .then((res) => {
                    console.log('res', res)
                    this.skuList = res.data
                })
                .catch((err) => { })
        }
    },
    watch: {
        config: {
            handler: function (curr) {
                console.log(curr)
                if (curr && curr.goodsList && curr.bottomImg && curr.title && curr.subTitle) {
                    console.log(1111111111111)
                    this.floorConfig.curr = curr
                    this.floorConfig.validated = true
                    // this.floorConfig = { ...curr, validated: true }
                }
                // this.floorConfig.curr.title=JSON.parse(this.floorConfig.curr.title)

                console.log(this.floorConfig.curr.bottomImg.value.url)
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.floor {
    &_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;

        &_border {
            display: inline-block;
            width: 5px;
            height: 28px;
            background-color: $base-color;
            margin-right: 12px;
            vertical-align: top;
        }

        &_content {
            font-size: 20px;
            padding-top: 10px;
            padding-bottom: 10px;
            /* height: 48px; */
            line-height: 28px;
            // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
            box-sizing: border-box;

            &_index {
                display: inline-block;
                color: $ns-text-color-black;
                padding-right: 8px;
                font-weight: 600;
            }

            &_text {
                font-weight: 600;
                display: inline-block;
                color: $base-color;
            }
        }

        .other-title {
            a {
                color: #838383;

                i {
                    font-size: 14px;
                }

                &:hover {
                    color: $base-color;
                }
            }
        }
    }

    .el-image {
        width: 100%;
        height: 100%;
        z-index: 100;
    }

    .floor-content {
        display: flex;
        width: 100%;

        // height: 600px;
        .floor-right {
            width: 50%;

            // cursor: pointer;
            .floor-right-top {
                height: 62%;
                display: flex;

                .top-first {
                    width: 35%;
                    height: 100%;
                    overflow: hidden;
                }

                .top-second {
                    width: 65%;
                    height: 100%;
                    overflow: hidden;
                }
            }

            .floor-right-bottom {
                height: 38%;
                display: flex;

                .bottom-first {
                    width: 35%;
                    height: 100%;
                    overflow: hidden;
                }

                .bottom-second {
                    width: 65%;
                    height: 100%;
                    overflow: hidden;
                }
            }
        }

        .floor-left {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            align-content: space-between;

            .floor-left-item {
                width: 17.3%;
                height: 300px;
                box-sizing: border-box;
                background-color: #ffffff;
                padding: 12px 17px;
                border: 1px solid #e9e9e9;
                border-top: none;
                border-left: none;
                // cursor: pointer;
                margin: 5px 2px;

                &:nth-child(-n + 3) {
                    border-top: 1px solid #e9e9e9;
                }

                &:nth-child(3n + 1) {
                    border-left: 1px solid #e9e9e9;
                }

                .floor-left-title {
                    width: 100%;
                    font-size: $ns-font-size-base;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-top: 5px;
                }

                .floor-left-sub-title {
                    font-size: $ns-font-size-sm;
                    color: $base-color;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .floor-left-img-wrap {
                    width: 100%;
                    height: 177px;

                    .item_image {
                        height: 100%;
                    }
                }
            }
        }
    }
}
</style>
